// 👇️ ts-ignore ignores any ts errors on the next line
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// // 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
// @ts-ignore

import React, { useState, useEffect } from "react"
import { useHistory } from "react-router"
import InputField from "../../components/InputField"
import SearchBar from "pages/dashboard/Searchbar"
import Button from "../../components/Button"
import { sendForApproval } from "../../core/services/api"
import { getRmoApprovalRequestDetails } from "../../core/services/api"
import "./ApprovalRequest.scss"
import Select from "react-select"
import { styled } from "@mui/material/styles"
import { searchByPatientName } from "../../core/services/api"
import Toast from "../../components/Toast"
import moment from "moment"
import { useSelector } from "react-redux"
import { MocUserRole } from "../../core/services/models/Enums"
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip'


function ApprovalRequest({ displayToast, toggleToast, consultantDetailsResult = [] }: any) {
  const history = useHistory()
  const userDetail = useSelector((state: any) => state?.user?.userDetail)
  const [patientIds, setPatientIds] = useState<string[]>([])
  const [patientDetailsResult, setPatientDetailsResult] = useState<string[]>([])
  // const [consultantDetailsResult, setConsultantDetailsResult] = useState<
  //   string[]
  // >([])
  const [approvalSendingResult, setApprovalSendingResult] = useState<string[]>(
    []
  )
  const [approvalPendingResult, setApprovalPendingResult] = useState<string[]>(
    []
  )
  const [data, setData] = useState<string[]>([])
  const [searchResult, setSearchResult] = useState<any>()
  const [patientInfo, setpatientInfo] = useState<object>({
    patientId: "",
    consultantName: "",
    approvalReason: "",
    appointmentDate: "",
  })
  const [patientName, setPatientName] = useState<string>()
  const [patientId, setPatientId] = useState<string>()
  const [formErrors, setFormErrors] = useState({})
  const [isSubmit, setIsSubmit] = useState(false)
  const userRole = useSelector((state: any) => state?.user?.role)

  const [sortByTime, updateSortBy] = useState("DESC");
  const [isLoading, setIsLoading] = useState<boolean>(false)

  //Pagination
  const [pages, setPages] = useState<any>(0)
  const [currPage, setCurrPage] = useState<any>(0)
  const [pageSize, setPageSize] = useState<any>(10)
  //Search For Patient Directory
  const [searchText, setSearchText] = useState<any>("")

  useEffect(() => {
    fetchRmoApprovalRequestDetails()
  }, [pageSize, currPage, searchText, sortByTime])

  useEffect(() => {
    let test = patientInfo?.patientId?.label
    const value = test?.split("-").pop()
    setPatientName(value)
    var result = test?.split("-")[0]

    // setPatientId(item.id)




    const patientNameValue = patientDetailsResult.filter((item) => {
      if (item.mocId === result) {
        setPatientName(item?.isVIP ? item?.mocId : item.name)
        setPatientId(item.id)
      }
    })
  }, [patientInfo?.patientId])

  // function fetchPatientDetails() {
  //   getallPatientDetail(`?centerId=${userDetail?.currentCenter?.centerId}`)
  //     .then((res) => {

  //       const { data }: any = res
  //       setPatientDetailsResult(data)
  //       const patientDetailsArray = res?.data?.map((elem) => {
  //         return {
  //           label: elem?.isVIP ? elem?.mocId : `${elem?.mocId}-${elem?.name}`,
  //           value: elem?.id,
  //         }
  //       })

  //       setPatientIds(patientDetailsArray)
  //     })
  //     .catch((err) => { })
  // }

  function fetchRmoApprovalRequestDetails() {
    let url = ""
    if (searchText) {
      url = `/pagination?page=${currPage}&pageSize=${pageSize}&searchText=${searchText}`
    } else {
      url = `/pagination?page=${currPage}&pageSize=${pageSize}`
    }

    if (sortByTime) {
      url += `&sortBy=approvalRaisedTime&sortDirection=${sortByTime}`
    }
    let userRoleQueryParam = '';
    if (userRole === MocUserRole.RMO) {
      userRoleQueryParam = `rmoId=${userDetail?.id}`;
    } else if (userRole === MocUserRole.CONSULTANT) {
      userRoleQueryParam = `consultantId=${userDetail?.id}`;
    }

    const combinedUrl = userRoleQueryParam ? `${url}&${userRoleQueryParam}` : url;
    getRmoApprovalRequestDetails(combinedUrl)
      .then((res) => {

        const { data, totalPages, totalCount } = res
        setPages(totalPages)
        //const temp = [...res]
        // data?.sort((a: any, b: any) => {
        //   return sortByTime === "asc" ?
        //     a?.approvalRaisedTime > b?.approvalRaisedTime ? 1 : -1
        //     : a?.approvalRaisedTime < b?.approvalRaisedTime ? 1 : -1
        // })
        setApprovalPendingResult(data)
        setData(data)
      })
      .catch((err) => {
        console.log("Err", err)
      })
  }




  const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.white,
      color: 'rgba(0, 0, 0, 0.87)',
      boxShadow: theme.shadows[1],
      fontSize: 11,
    },
  }));


  const handleSubmit = (e) => {
    e.preventDefault()
    setFormErrors(validate(patientInfo))
    setIsSubmit(true)
  }

  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      // setIsLoading(true)
      const approvalRequest = {
        rmoId: userDetail?.id,
        consultantId: patientInfo?.consultantId,
        patientId: patientId,
        rmoName: userDetail?.name,
        approvalFor: patientInfo.approvalReason,
        appointmentDate: patientInfo.appointmentDate,
        centerId: userDetail?.currentCenter?.centerId,
        recordId: "",
        status: "PENDING",
        reason: ""
      }
      sendForApproval(approvalRequest)
        .then((result) => {
          setIsLoading(false)
          toggleToast({
            type: "success",
            text: `Approval Request has been sent successfully`,
          })
          setApprovalSendingResult(result)
          setpatientInfo({})
          setPatientName("")
          fetchRmoApprovalRequestDetails()

        })

        .catch((err) => {
          setIsLoading(false)
          toggleToast({
            type: "error",
            text: err?.response?.data?.message
              ? err?.response?.data?.message
              : `Unable to send Approval request`,
          })
          console.log("Error:", err)
        })
      setpatientInfo({})
      patientInfo.patientId = ""
      setPatientName("")
    }
  }, [formErrors])

  const validate = (values) => {
    const errors = {}
    // drpodown validation
    if (values.consultantId == "") {
      errors.consultantId = "Consultant name required"
    }
    if (values.patientId == "") {
      errors.patientId = "Patient ID required"
    }
    if (values.approvalReason == "") {
      errors.approvalReason = "Approval reason required"
    }
    if (values.appointmentDate == "") {
      errors.appointmentDate = "Appointment date required"
    }
    return errors
  }

  useEffect(() => {
    if (sortByTime) {
      const temp = [...approvalPendingResult]
      temp?.sort((a: any, b: any) => {
        return sortByTime === "asc" ?
          a?.approvalRaisedTime > b?.approvalRaisedTime ? 1 : -1
          : a?.approvalRaisedTime < b?.approvalRaisedTime ? 1 : -1
      })
      setApprovalPendingResult(temp)
    }
  }, [sortByTime])

  const handleSortOption = (e) => {
    updateSortBy(sortByTime === "ASC" ? "DESC" : "ASC")
  }

  const handleSearch = (e) => {
    e.length
      ? searchByPatientName(e)
        .then((res) => {
          const temp = [...res]
          temp?.sort((a: any, b: any) => {
            return sortByTime === "asc" ?
              a?.approvalRaisedTime > b?.approvalRaisedTime ? 1 : -1
              : a?.approvalRaisedTime < b?.approvalRaisedTime ? 1 : -1
          })
          setApprovalPendingResult(temp)
        })
        .catch((err) => {
          console.log("search err", err)
        })
      : fetchRmoApprovalRequestDetails()
  }
  const handleEdit = async (id: any, patientId: any, recordId: any) => {
    // history.push(`/addNewReferrals`, path)
    history.push({
      pathname: "/consultantApprovalRequest",
      state: {
        idValue: id,
        patientIdValue: patientId,
        recordIdValue: recordId,
      },
    })
  }

  useEffect(() => {
    if (searchResult) {

      setPatientName(searchResult?.name);
      setPatientId(searchResult?.id)
    }
  }, [searchResult])
  const handlePatientIdSelected = (selectedPatientId) => {

    setpatientInfo({
      ...patientInfo,
      patientId: selectedPatientId?.mocId,
    })
    setSearchResult(selectedPatientId);
  };


  return (
    <div className="approval-request-wrapper">
      {
        isLoading ? (
          <div
            style={{
              position: "absolute",
              top: "50%",
              right: "45%",
            }}
          >
            <div
              style={{ width: "3rem", height: "3rem" }}
              className="spinner-border text-primary"
            ></div>
          </div>
        ) : ("")
      }
      <div className="approval-request-section">
        {/* <div className="approval-heading-container">
          <div
            className="approval-back-image"
            onClick={() => {
              history.push("/")
            }}
          >
            <img
              src={backImage}
              height={"60px"}
              width={"60px"}
              alt="back button"
              className="back_button"

            />
          </div>
          <div className="approval-request-text">Approval Requests</div>
        </div> */}
        {userRole === MocUserRole.RMO && (
          <section className="section-one-container">
            <div className="section-one-heading">New Approval Request</div>
            <div className="section-one-details">
              <form onSubmit={handleSubmit}>
                <div className="new-approval-request-form">
                  <div>
                    <div class="row justify-content-between mt-4 test">
                      <div class="col-md-7 col-lg-7 pl-2 ">
                        <div class="row align-items-center">
                          <div class="col-md-4 col-lg-4">
                            <label htmlFor="" className="label">
                              RMO ID:
                            </label>
                          </div>
                          <div class="col-md-6 col-lg-6">
                            <InputField
                              placeholder={"Choose"}
                              value={"MOC876523"}
                              readOnly={"true"}
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-5 col-lg-5">
                        <div class="row align-items-center">
                          <div class="col-md-4 col-lg-4">
                            <label htmlFor="" className="label">
                              Consultant Name:
                            </label>
                          </div>
                          <div class="col-md-6 col-lg-6">
                            {/* <Dropdown
                              placeholder="Choose"
                              options={consultantDetailsResult?.map((each) => { return { value: each?.id, label: each?.name } })}
                              selected={patientInfo.consultantId}
                              updateDropdown={(option) => {
                                setpatientInfo({
                                  ...patientInfo,
                                  consultantId: option
                                })
                              }}
                              errorMsg={formErrors.consultantName}
                            ></Dropdown> */}

                            <Select
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  border: "1px solid #ccd0e7",
                                  borderRadius: "10px"
                                })
                              }}
                              className="country-select"
                              options={consultantDetailsResult?.map((each) => { return { value: each?.id, label: each?.name } })}
                              onChange={(option: any) => {
                                setpatientInfo({
                                  ...patientInfo,
                                  consultantId: option?.value
                                })
                              }}
                              value={consultantDetailsResult?.map((each) => { return { value: each?.id, label: each?.name } })?.filter(
                                ({ value }: any) => value === patientInfo?.consultantId
                              )}
                              errorMsg={formErrors.consultantName}
                              placeholder="Choose"

                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div class="row justify-content-between mt-4 test">
                      <div class="col-md-7 col-lg-7 pl-2 ">
                        <div class="row align-items-center">
                          <div class="col-md-4 col-lg-4">
                            <label htmlFor="" className="label">
                              Patient ID:
                            </label>
                          </div>
                          <div class="col-md-6 col-lg-6 patientIdContainer">
                            {/* <Dropdown
                              options={patientIds}
                              placeholder={"Choose"}
                              selected={patientInfo.patientId}
                              updateDropdown={(option) => {
                                setpatientInfo({
                                  ...patienaddtInfo,
                                  patientId: option,
                                })
                              }}
                              errorMsg={formErrors.patientId}
                            ></Dropdown> */}

                            <SearchBar
                              componentParent={"ViewAllRequest"}
                              onPatientIdSelected={handlePatientIdSelected}
                              placeholder="Search Patient"
                            />

                            {formErrors?.patientId && <p style={{ color: "red", paddingLeft: "20px", paddingTop: "5px" }}>{formErrors.patientId}</p>}
                          </div>
                        </div>
                      </div>
                      <div class="col-md-5 col-lg-5">
                        <div class="row align-items-center">
                          <div class="col-md-4 col-lg-4">
                            <label htmlFor="" className="label">
                              Patient name:
                            </label>
                          </div>
                          <div class="col-md-6 col-lg-6">
                            <InputField value={patientName} readOnly={"true"} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="row justify-content-between mt-4 test">
                      <div class="col-md-7 col-lg-7 pl-2 ">
                        <div class="row align-items-center">
                          <div class="col-md-4 col-lg-4">
                            <label htmlFor="" className="label">
                              Appointment Date:
                            </label>
                          </div>
                          <div class="col-md-6">
                            <InputField
                              calendar={true}
                              value={patientInfo.appointmentDate}
                              placeholder={"DD - MM - YYYY"}
                              handleChange={(e) => {
                                setpatientInfo({
                                  ...patientInfo,
                                  appointmentDate: e.target.value.toString(),
                                })
                              }}
                              errorMsg={formErrors.appointmentDate}
                              style={{ paddingLeft: "4px" }}
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-5 col-lg-5"></div>
                    </div>
                  </div>
                  <div className="col-md-12 col-lg-12 row test mt-4">
                    <div class="col-md-7 col-lg-7 pl-2 ">
                      <div class="row align-items-center">
                        <div class="col-md-4 col-lg-4">
                          <label htmlFor="" className="label">
                            Approval For:
                          </label>
                        </div>
                        <div class="col-md-6 col-lg-6">
                          <InputField
                            value={patientInfo.approvalReason}
                            handleChange={(e) =>
                              setpatientInfo({
                                ...patientInfo,
                                approvalReason: e.target.value,
                              })
                            }
                            errorMsg={formErrors.approvalReason}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="send-approval-form">
                      <Button text="Send For Approval" type={"submit"} id="send-for-approval" />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </section>
        )}

        {displayToast ? (
          <Toast
            textMessage={displayToast?.text}
            onClose={() => toggleToast(false)}
            onCloseText={"Close"}
            type={displayToast?.type}
          />
        ) : (
          ""
        )}
        <section className="section-two-container">
          {userRole === MocUserRole.RMO && (
            <div className="section-two-heading">Approval Requests</div>
          )}
          <div className="search-dropdown-wrapper">
            <div className="row pl-42 pt-17px">
              <div className="col-md-6 col-lg-6">
                <span>
                  <input
                    className="inputGlobalSearch"
                    placeholder="Search"
                    onChange={(e) => {
                      // handleSearch(e.target.value)
                      setSearchText(e.target.value)
                      setCurrPage(0);
                    }}
                  />
                  <img
                    src="assets/images/searchIcon.svg"
                    alt=""
                    style={{
                      marginLeft: "-50px",
                      width: "26px",
                      height: "26px",
                    }}
                  />
                </span>
              </div>
              <div className="col-md-1 col-lg-1">
                {/* <Dropdown
                  placeholder="Sort"
                  options={rmoIdOptions}
                  selected=""
                ></Dropdown> */}
                <Button
                  type="button"
                  text="Sort By Time"
                  outline={true}
                  onClick={handleSortOption}
                  id="sort-by-time"
                />
              </div>
            </div>
          </div>
          {approvalPendingResult?.map((item) => {
            return (
              <div className="pending-appointment-request-wrapper">
                <div className="row patientid">
                  <div className="col-md-1 col-lg-1">
                    <label className="patient-id-container">Patient ID:</label>
                  </div>
                  <div className="col-md-2 col-lg-2 p-0 patientidvalue">
                    {item.patientMocId}
                  </div>
                  <div className="col-md-9 col-lg-9 editSection">
                    {userRole === MocUserRole.CONSULTANT && (
                      <div className="cursor-pointer" style={{ paddingLeft: "20px" }}>
                        <img
                          // className={globalStyles.pointer}
                          src={"../../../assets/images/CRedit.svg"}
                          alt="edit"
                          width={24}
                          height={24}
                          onClick={() =>
                            handleEdit(
                              item?.id,
                              item?.patientId,
                              item?.recordId
                            )
                          }
                        />
                      </div>
                    )}
                  </div>
                </div>

                <div className="row pt-28 patientdetails">
                  <div className="col-12 d-flex">
                    <div className="col-4 pl-47 sectionone">
                      <div className="row">
                        <div className="col-12 d-flex pt-24">
                          <div className="col-4">
                            <label className="patient-id-container">
                              Patient name:
                            </label>
                          </div>

                          <div className="col-8">
                            <label className="values-container">
                              {item.patientName}
                            </label>
                          </div>
                        </div>
                        <div className="col-12 d-flex">
                          <div className="col-4">
                            <label className="patient-id-container">
                              Consultant Name:
                            </label>
                          </div>

                          <div className="col-8">
                            <label className="values-container">
                              {item.consultantName}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-4 pl-47 sectiontwo">
                      <div className="row">
                        <div className="col-12 d-flex">
                          <div className="col-4">
                            <label className="patient-id-container">
                              Date:
                            </label>
                          </div>

                          <div className="col-8">
                            <label className="values-container">
                              {/* {item.approvalRaisedTime?.slice(0, 10)}
                               */}
                              {item?.approvalRaisedTime
                                ? moment(item?.approvalRaisedTime).format(
                                  "DD-MM-YYYY"
                                )
                                : ""}
                            </label>
                          </div>
                        </div>
                        {item?.vitalCaptureDate && (
                          <div className="col-12 d-flex">
                            <div className="col-4">
                              <label className="patient-id-container">
                                Vital Date:
                              </label>
                            </div>

                            <div className="col-8">
                              <label className="values-container">
                                {item?.vitalCaptureDate
                                  ? moment(item?.vitalCaptureDate).format(
                                    "DD-MM-YYYY"
                                  )
                                  : ""}
                              </label>
                            </div>
                          </div>
                        )}
                        <div className="col-12 d-flex">
                          <div className="col-4">
                            <label className="patient-id-container">
                              Time:
                            </label>
                          </div>

                          <div className="col-8">
                            <label className="values-container">
                              {/* {item.approvalRaisedTime?.slice(11)} */}
                              {item.approvalRaisedTime
                                ? moment(item.approvalRaisedTime).format(
                                  "HH:mm:ss a"
                                )
                                : ""}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-4 pl-47 sectionthree">
                      <div className="row">
                        <div className="col-12 d-flex">
                          <div className="col-4">
                            <label className="patient-id-container">
                              Contact Number:
                            </label>
                          </div>

                          <div className="col-8">
                            <label className="values-container">
                              {item.contactNumber}
                            </label>
                          </div>
                        </div>
                        <div className="col-12 d-flex">
                          <div className="col-3">
                            <label className="patient-id-container">
                              Email:
                            </label>
                          </div>
                          <LightTooltip title={item.email}>
                            <div className="col-9">
                              <label className="values-containers">
                                {item.email}
                              </label>
                            </div>
                          </LightTooltip>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row complaintsection">
                  <div className="col-1">
                    <label className="patient-id-container">Complaint:</label>
                  </div>
                  <div className="col-11 complaintreason">
                    <label className="values-container">
                      {item.approvalFor}
                    </label>
                  </div>
                </div>
                <div className="row statussection">
                  <div className="col-1">
                    <div className="row">
                      <label className="patient-id-container">Status:</label>
                      <label className="patient-id-container">Advice:</label>
                    </div>
                  </div>
                  <div className="col-11 statusdetails">
                    <div className="row">
                      <label className="values-container">{item.status}</label>
                      <label className="values-container">{item.reason}</label>
                    </div>
                  </div>
                </div>
              </div>
            )
          })}
        </section>
        {/* Pagination */}

        {
          data && data?.length > 0 ? (
            <div
              style={{ marginTop: "20px" }} className="pagination-footer"
            >
              <button
                className="pagination-button"
                onClick={() => {
                  setCurrPage(0);
                }}
                disabled={currPage === 0}
              >
                {"First"}
              </button>
              <button
                className="pagination-button"
                onClick={() => {
                  setCurrPage(currPage - 1);
                }}
                disabled={currPage === 0}
              >
                {"Previous"}
              </button>
              <span className="pagination-text">
                Page{" "}
                <strong>
                  {currPage + 1} of {pages}
                </strong>
              </span>
              <button
                className="pagination-button"
                onClick={() => {
                  setCurrPage(currPage + 1);
                }}
                disabled={currPage === pages - 1}
              >
                {"Next"}
              </button>
              <button
                className="pagination-button"
                onClick={() => {
                  setCurrPage(pages - 1);
                }}
                disabled={currPage === pages - 1}
              >
                {"Last"}
              </button>
              <select
                className="pagination-select"
                value={pageSize}
                onChange={(e) => {
                  setPageSize(Number(e.target.value));
                  setCurrPage(0);
                }}
              >
                {[10, 15, 20, 25, 50].map((pageSize) => (
                  <option key={pageSize} value={pageSize}>
                    {pageSize}
                  </option>
                ))}
              </select>
            </div>
          ) : null
        }
      </div>
    </div>
  )
}

export default ApprovalRequest
